var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7812 20H0.976562C0.437222 20 0 19.5628 0 19.0234V0.976562C0 0.437222 0.437222 0 0.976562 0H10.7812C11.3206 0 11.7578 0.437222 11.7578 0.976562C11.7578 1.5159 11.3206 1.95312 10.7812 1.95312H1.95312V18.0469H10.7812C11.3206 18.0469 11.7578 18.4841 11.7578 19.0234C11.7578 19.5628 11.3206 20 10.7812 20ZM16.6605 10.9766H7.30469C6.76535 10.9766 6.32812 10.5393 6.32812 10C6.32812 9.46066 6.76535 9.02344 7.30469 9.02344H16.6605L13.3762 5.74961C13.1219 5.50484 13.0195 5.14194 13.1083 4.80038C13.1971 4.45881 13.4633 4.19173 13.8046 4.10178C14.1458 4.01182 14.5091 4.11299 14.7547 4.36641L19.7133 9.3082C19.8972 9.49145 20.0006 9.74038 20.0006 10C20.0006 10.2596 19.8972 10.5086 19.7133 10.6918L14.7547 15.6336C14.572 15.8164 14.3241 15.919 14.0656 15.9188C13.6703 15.9188 13.3139 15.6805 13.1629 15.3152C13.0119 14.9498 13.0961 14.5294 13.3762 14.2504L16.6605 10.9766Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.184dc882dfe5e8b96f69cb0109539984.svg";
export { ForwardRef as ReactComponent };